export const tutoringLoading =  ({store})  => store.tutoringReducer.loading;

export const tutoringError =  ({store})  => store.tutoringReducer.error;

export const tutoringData =  ({store})  => store.tutoringReducer.data;